<div class="wrapper">
    <img src="../../assets/Offline/Offline.png" class="image-css" alt="Offline">
    <h1>OFFLINE</h1>
    <h4>Please check your internet connection</h4>
</div>